import * as React from 'react';
import { IconProps } from '../types';

const IcEdit = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
       <g clipPath="url(#a)">
      <path
        fill={props?.fill ?? '#232F3E'}
        fillRule="evenodd"
        d="M.367 23.857H23.98V21.62H.367v2.238Zm8.264-7.831v-3.01l10.123-8.993 2.161 2.283-9.255 9.72H8.63Zm15.736-9.717L18.82 1 6.27 12.072v6.191h6.4L24.367 6.31Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.367 0h24v24h-24z" />
      </clipPath>
    </defs>
  </svg>
);

export default IcEdit;
